var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock4Img3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 101,
    viewBox: "0 0 72 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.6379 94.5627C71.6373 96.0653 71.0439 97.5059 69.9894 98.5686C68.9341 99.6313 67.5046 100.229 66.0129 100.23H5.99169C4.5002 100.23 3.06975 99.6334 2.01413 98.5716C0.958611 97.5097 0.364488 96.0697 0.362062 94.5671V6.05435C0.361468 5.30933 0.506719 4.57152 0.789414 3.88309C1.07217 3.19465 1.48675 2.56915 2.00974 2.04233C2.53247 1.5155 3.15332 1.09773 3.83662 0.812913C4.51992 0.528018 5.25236 0.381738 5.99169 0.382326H44.5117L71.6379 28.2548V94.5627Z",
    fill: "#23A566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4966 27.5285L71.6374 50.7768V28.093H50.2534C49.3197 28.1035 48.3993 27.8702 47.5813 27.4155L47.4966 27.5285Z",
    fill: "#1C8F5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6375 28.2103H50.1953C48.7038 28.2091 47.2734 27.6115 46.2188 26.549C45.1643 25.4863 44.5711 24.0454 44.5696 22.5428V0.229492L71.6375 28.2103Z",
    fill: "#8ED1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4765 81.8227H17.3865V49.4209H54.4765V81.8227ZM38.2377 54.0952V59.7665H49.9178V54.104L38.2377 54.0952ZM38.2377 63.3392V68.7577H49.9178V63.3119L38.2377 63.3392ZM38.2377 72.2125V77.2302H49.9178V72.1859L38.2377 72.2125ZM33.6525 77.203V72.1859H21.976V77.203H33.6525ZM33.6525 68.6996V63.3119H21.976V68.7268L33.6525 68.6996ZM33.6525 59.8255V54.0952H21.976V59.7665L33.6525 59.8255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock4Img3);
export default __webpack_public_path__ + "static/media/block_4_img_3.07647c82bb79bcecd4ed6473fdf5710c.svg";
export { ForwardRef as ReactComponent };